import axios from 'axios';
import DebugService from './DebugService';
import { tracer } from '../traces';
import APIConstants from './APIConstants';
import { context, propagation, trace } from '@opentelemetry/api';

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_BASE_URL = (process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'staging')
  ? process.env.REACT_APP_API_BASE_STAGING_URL
  : process.env.REACT_APP_API_BASE_URL;

export const AxiosService = axios.create({
  baseURL: API_BASE_URL,
})

export const setAuthToken = (token) => {
  if (token) {
    AxiosService.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete AxiosService.defaults.headers.common['Authorization'];
  }
}

const APIService = {
  // Generic function for making HTTP GET requests
  get: async (endpoint) => {
    const span = tracer.startSpan(`GET ${endpoint}`)
    // Create a new context with the active span
    const ctxWithSpan = trace.setSpan(context.active(), span)

    // Inject trace headers into the request config
    const headers = AxiosService.defaults.headers || {}
    propagation.inject(ctxWithSpan, headers)

    try {
      const response = await AxiosService.get(`/${endpoint}`);

      if(response.data['error'] && response.data['error']['code'] === 401) {
        window.location.href = '/sign-in?reason=unauthorized'
      }

      return response.data;
    } catch (error) {
      DebugService.error(`Error making GET request to ${endpoint}:`, error);
      span.recordException(error)
      throw error;
    } finally {
      span.end()
    }
  },

  // Generic function for making HTTP POST requests
  post: async (endpoint, data) => {
    try {
      const response = await AxiosService.post(`/${endpoint}`, data);

      // if(response.data['error'] && response.data['error']['code'] === 401) {
      //   window.location.href = '/sign-in?reason=unauthorized'
      // }
      
      if (response.data['error'] && response.data['error']['code'] === 401) {
        const AUTH_ENDPOINTS = [
          APIConstants.ENDPOINT_LOGIN,
          APIConstants.ENDPOINT_REGISTRATION
        ]
        if (!AUTH_ENDPOINTS.includes(endpoint)) {
          window.location.href = '/sign-in?reason=unauthorized'
        }
      }

      if (response.status !== 200) {
        throw new Error('Caught error while saving details..', response)
      }

      return response.data;
    } catch (error) {
      DebugService.error(`Error making POST request to ${endpoint}:`, error);
      throw error;
    }
  },

  // Generic function for making HTTP PUT requests
  put: async (endpoint, data) => {
    try {
      const response = await AxiosService.put(`/${endpoint}`, data);

      if(response.data['error'] && response.data['error']['code'] === 401) {
        window.location.href = '/sign-in?reason=unauthorized'
      }

      return response.data;
    } catch (error) {
      DebugService.error(`Error making PUT request to ${endpoint}:`, error);
      throw error;
    }
  },

  // Generic function for making HTTP DELETE requests
  delete: async (endpoint) => {
    try {
      const response = await AxiosService.delete(`/${endpoint}`);

      if(response.data['error'] && response.data['error']['code'] === 401) {
        window.location.href = '/sign-in?reason=unauthorized'
      }
      
      return response.data;
    } catch (error) {
      DebugService.error(`Error making DELETE request to ${endpoint}:`, error);
      throw error;
    }
  },
};

export default APIService;
